import React from "react";
import { Image, TouchableOpacity } from "react-native";
import { getImage } from "../assets/Images";
import commonStyles, { COLOR5 } from "../styles/commonStyles";

export const DEFAULT_HEADER_STYLE = {
	backgroundColor: COLOR5,
	elevation: 0,
	shadowOpacity: 0,
	borderBottomWidth: 0
};

export const getCommunityUri = communityDetails => {
	return communityDetails
		? communityDetails.customUri
			? communityDetails.customUri
			: communityDetails._id
		: "";
};

export const getHeaderLeftBack = (navigation, options) => {
	const { flex1, bgColor2, justifyContentCenter, alignItemsCenter } =
		commonStyles;

	return () => (
		<TouchableOpacity
			style={[
				bgColor2,
				alignItemsCenter,
				justifyContentCenter,
				{
					// `@react-navigation/elements` v2 lays the header's left slot out
					// as a row sized by its content, so `flex: 1` here would collapse
					// the button to zero width and `height: "100%"` to zero height,
					// leaving only the overflowing arrow visible. Stretch instead.
					alignSelf: "stretch",
					width: 56,
					paddingBottom: 3
				}
			]}
			onPress={() => {
				if (options?.origin) {
					navigation.navigate(options.origin);
				} else if (navigation?.canGoBack()) {
					navigation.goBack();
				} else if (options?.fallback) {
					// No back stack (e.g. opened directly via URL / page refresh on
					// web): fall back to a sensible screen instead of doing nothing.
					navigation.navigate(options.fallback);
				}
				if (options?.callback) {
					options.callback();
				}
			}}
		>
			<Image style={{ width: 20, height: 20 }} source={getImage("back")} />
		</TouchableOpacity>
	);
};
